var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 18c4.924 0 9-4.085 9-9 0-4.924-4.085-9-9.009-9C4.076 0 0 4.076 0 9c0 4.915 4.085 9 9 9m0-1.5A7.464 7.464 0 0 1 1.509 9c0-4.165 3.317-7.5 7.482-7.5s7.5 3.335 7.509 7.5A7.466 7.466 0 0 1 9 16.5M8.92 5.859a1.14 1.14 0 0 0 1.148-1.147c0-.644-.503-1.156-1.147-1.156-.636 0-1.147.512-1.147 1.156 0 .635.511 1.147 1.147 1.147m-1.464 7.994h3.591c.362 0 .644-.256.644-.618a.626.626 0 0 0-.644-.617H9.953V8.126c0-.476-.238-.794-.688-.794h-1.66a.626.626 0 0 0-.643.618c0 .362.282.618.644.618h.944v4.05H7.456a.626.626 0 0 0-.644.617c0 .362.282.618.644.618"
  })));
};
export default SvgInfo;